module.exports = __webpack_public_path__ + "img/dd9704f.jpg";